import { Routes, Route } from "react-router-dom";
import HomePage from "../homePage";
import PackagesPage from "../Packages/packagesPage";
import RegisterPage from "../Pages/CustomerDetails";
import AboutUsPage from "../Pages/AboutUs";
import PricingPage from "../Pages/Contactus";
import UpgradePage from "../Packages/Upgrade";


function AppRoutes() {
  return (
    <Routes>
      <Route path="/packages" element={<PackagesPage/>}></Route> 
      <Route path="/register" element={<RegisterPage/>}></Route> 
      <Route path="/about-us" element={<AboutUsPage/>}></Route>
      <Route path="/pricing" element={<PricingPage/>}></Route>
      <Route path="/upgrade" element={<UpgradePage/>}></Route>
    </Routes>
  );
}
export default AppRoutes;
